export const getAllowedLocations = (treeData) => {
  const allowedLocations = [];

  const getCheckedChildren = (location) => {
    if (!location.disabled) {
      allowedLocations.push(location);
    }

    if (location.children.length) {
      location.children.forEach((subLocation) => getCheckedChildren(subLocation));
    }
  };

  treeData.forEach((facility) => getCheckedChildren(facility));

  return allowedLocations;
};